import iconsUIConfig from './icons/iconsUIConfig';
import tailwindcssUIConfig from './tailwindcss/tailwindcssUIConfig';
import typographyUIConfig from './typography/typographyUIConfig';
import pageLayoutsUIConfig from './page-layouts/pageLayoutsUIConfig';

const userInterfaceConfigs = [
  iconsUIConfig,
  tailwindcssUIConfig,
  typographyUIConfig,
  pageLayoutsUIConfig,
];

export default userInterfaceConfigs;
